import { Pipe, PipeTransform } from '@angular/core';
import {Person} from '@app/views/databrowsing/model/rostering.models';
import {DataBrowsingService} from '@app/views/databrowsing/databrowsing.service';

@Pipe({
    name: 'combinedPersonData'
})
export class CombinedPersonDataPipe implements PipeTransform {
    transform(entity: Person, includeGuid: boolean = false, addTitle: boolean = false): string {
        return DataBrowsingService.getPersonFriendlyName(entity, includeGuid, addTitle);
    }

}
